import type { DpAttachment, DpRequest } from '../../../../shared/dpRequests';
import { REQUEST_TYPE_LABELS } from '../dpRequests.definitions';

export interface DpDocumentRow {
    key: string;
    requestId: string;
    collaboratorId: string;
    collaboratorName: string;
    collaboratorEmail: string;
    typeLabel: string;
    attachment: DpAttachment;
    createdAt: Date;
}

export function flattenDpDocuments(requests: readonly DpRequest[]): DpDocumentRow[] {
    const rows: DpDocumentRow[] = [];
    requests.forEach(request => {
        const attachments = (request as { attachments?: DpAttachment[] }).attachments ?? [];
        attachments.forEach((attachment, index) => {
            rows.push({
                key: `${request.id}-${index}`,
                requestId: request.id,
                collaboratorId: request.collaboratorId,
                collaboratorName: request.collaboratorName,
                collaboratorEmail: request.collaboratorEmail,
                typeLabel: REQUEST_TYPE_LABELS[request.type],
                attachment,
                createdAt: request.createdAt.toDate(),
            });
        });
    });
    return rows.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
}

export function matchesDocumentSearch(row: DpDocumentRow, term: string): boolean {
    const search = term.trim().toLowerCase();
    if (search === '') return true;
    return (
        row.collaboratorName.toLowerCase().includes(search) ||
        row.collaboratorEmail.toLowerCase().includes(search) ||
        row.attachment.name.toLowerCase().includes(search)
    );
}
